import { memo, ReactElement } from 'react';

const NightIcon = (props: { className?: string }): ReactElement => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3748 16.1254C21.0215 16.0067 21.6586 15.827 22.2772 15.587C22.0228 16.2429 21.7045 16.8682 21.3288 17.4547C20.5731 18.6342 19.5853 19.6567 18.4177 20.4559C16.6697 21.6525 14.6006 22.2926 12.4822 22.292C10.0348 22.2868 7.66609 21.4272 5.78494 19.8617C3.90379 18.2961 2.62833 16.1229 2.17876 13.7171C1.7292 11.3114 2.13376 8.82417 3.32258 6.68492C4.16873 5.16231 5.37438 3.88399 6.82135 2.95313C7.40734 2.57615 8.03292 2.25616 8.69022 2C8.44984 2.61955 8.26996 3.25755 8.15127 3.90523C7.90627 5.24216 7.92203 6.62034 8.20483 7.96262C8.62464 9.95518 9.61477 11.7827 11.0547 13.2226C12.4945 14.6624 14.322 15.6526 16.3146 16.0724C17.6578 16.3554 19.037 16.371 20.3748 16.1254ZM19.209 17.7757C18.1409 17.8408 17.0634 17.7631 16.0054 17.5402C13.7281 17.0604 11.6396 15.9288 9.99399 14.2832C8.34841 12.6376 7.21683 10.5491 6.73705 8.27186C6.51472 7.21657 6.43681 6.14186 6.50098 5.07645C5.7581 5.74101 5.12517 6.52921 4.63372 7.41355C3.61466 9.24732 3.26787 11.3794 3.65324 13.4416C4.03861 15.5038 5.13194 17.3667 6.74447 18.7087C8.35658 20.0504 10.3865 20.7872 12.4838 20.792C14.2992 20.7922 16.0724 20.2436 17.5704 19.2181C18.1764 18.8033 18.726 18.3183 19.209 17.7757Z"
        fill="#949494"
      />
    </svg>
  );
};

export default memo(NightIcon);
